<template>
  <div class="row" v-if="$store.state.userData">
    <div class="col-sm-12 text-center" v-if="$store.state.userData.statements.length === 0">
      <div class="card">
        <div class="card-content">
          <h2>No Online Statements Available</h2>
        </div>
      </div>
    </div>
	<div class="col-sm-12 year-filter" v-if="$store.state.userData.statements.length > 0">
		<el-select
		  class="select-default"
		  v-model="limits.year"
		  placeholder="Filter by Year">
		  <el-option
			class="select-default"
			v-for="item in limits.years"
			:key="item"
			:label="item"
			:value="item"
            @change="updateListing($event)">
		  </el-option>
		</el-select>
	</div>
    <div class="col-sm-6" v-for="(statement, key) in filteredData" :key="key" v-model="displayStatements">
      <div class="card">
        <div class="card-content">
          <div class="row">
            <div class="col-xs-3">
              <div class="text-center icon-danger" style="font-size: 6em; width: inherit"><i class="fa fa-file-pdf-o"></i></div>
            </div>
            <div class="col-xs-9">
              <h4 class="card-title">
                {{ statement.filename.substring(7) }}
              </h4>
              <h6>Download:</h6>
              <button class="btn btn-fill text-center pull-left" style="margin-bottom: 5px;" @click="downloadStatement(statement.filename)"><span class="ti-download"></span> Statement</button> 
              <button style="margin-left: 5px;" v-if="statement.insert" class="btn btn-fill text-center pull-left" @click="downloadInsert(statement.filename)"><span class="ti-download"></span> Insert</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table class="table-striped"
                      :data="[{'test': 5}]"
                      border
                      style="width: 100%">
    </el-table>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Table, Select, Option } from 'element-ui'

  Vue.use(Table) // Imported to fix iOS rendering issues
  Vue.use(Select)
  Vue.use(Option)
  export default {
    computed: {
      filteredData () {
        return Array.from(new Set(this.$store.state.userData.statements
            .filter((statement) => statement.filename.substr(-4) === this.limits.year)))
      }
    },
    data () {
      return {
        limits: {
          year: Array.from(new Set(this.$store.state.userData.statements
            .map((statement) => statement.filename.substr(-4))
            .sort((a, b) => a < b)
            ))[0],
          years: Array.from(new Set(this.$store.state.userData.statements
            .map((statement) => statement.filename.substr(-4))
            .sort((a, b) => a < b)))
        },
        displayStatements: []
      }
    },
    methods: {
      downloadStatement: function (statement) {
        this.$http({
          url: '/client/downloadStatement/' + statement,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          this.downloadFile(response, statement + ' - ' + this.$store.state.userData.clientData.AuthCode + this.$store.state.userData.clientData.TribalId + ' Statement.pdf')
        })
      },
      downloadInsert: function (statement) {
        this.$http({
          url: '/client/downloadInsert/' + statement,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          this.downloadFile(response, statement + ' - ' + this.$store.state.userData.clientData.AuthCode + ' Insert.pdf')
        })
      },
      downloadFile: function (file, name) {
        const blob = new Blob([file.data], {type: 'application/pdf'})
        if (window.navigator.msSaveOrOpenBlob) { // IE 11+
          window.navigator.msSaveOrOpenBlob(blob, name)
        } else {
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          // link.setAttribute('target', '_blank')
          link.setAttribute('download', name)
          document.body.appendChild(link)
          link.click()
        }
      },
      updateListing: function () {
        this.displayStatements = this.$store.state.userData.statements
      }
    }
  }
</script>
<style>
.year-filter {
	margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Statements.vue